import Vue from 'vue'
import Router from 'vue-router'
import VueCookies from 'vue-cookies'

import Dashboard from '../screens/Dashboard'
import VesselView from '../screens/VesselView'
import EngineFaults from '../screens/EngineFaults'
import EnginePerformance from '../screens/EnginePerformance'
import UserSettings from '../screens/UserSettings'
import Register from '../screens/Register'
import Login from '../screens/Login'
import Alerts from '../screens/Alerts'
import DailyReport from '../screens/DailyReport'
import FaultsHistory from '../screens/FaultsHistory'
import EngineFaultDetail from '../screens/EngineFaultDetail'

import {globalStore, vessels} from "../main.js"

Vue.use(Router);
Vue.use(VueCookies);

var router = new Router({
    mode: "history",
    routes: [
        {
            path: '/dashboard',
            name: 'Dashboard',
            component: Dashboard,
        },
        {
            path: '/vessel-view/:vessel/:date?/',
            name: 'Vessel View',
            component: VesselView
        },
        {
            path: '/engine-performance/:vessel',
            name: 'Engine Performance',
            component: EnginePerformance,
            children: [
                {
                    path: 'engine/:eng',
                    children: [
                        {
                            path: 'on/:date',
                        }
                    ]
                },
                {
                    path: 'on/:date',
                }
            ]
        },
        {
            path: '/engine-faults/:vessel',
            name: 'Engine Faults',
            component: EngineFaults,
            children: [
                {
                    path: 'engine/:eng',
                    children: [
                        {
                            path: 'on/:date',
                            children: [
                                {
                                    path: 'fault/:id'
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'on/:date',
                    children: [
                        {
                            path: 'fault/:id'
                        }
                    ]
                }
            ]
        },
        // {
        //     path: '/faults-history/:vessel/:eng?',
        //     name: 'Faults History',
        //     component: FaultsHistory
        // },
        {
            path: '/report/:vessel',
            name: 'Report',
            component: DailyReport,
            children: [
                {
                    path: 'engine/:eng',
                    children: [
                        {
                            path: "on/:date"
                        }
                    ]
                },
                {
                    path: "on/:date"
                }
            ]
        },
        {
            path: '/engine-fault-detail',
            name: 'Engine Fault Detail',
            component: EngineFaultDetail,
        },
        {
            path: '/user-settings',
            name: 'Settings',
            component: UserSettings
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
        },
        {
            path: '/register',
            name: 'Register',
            component: Register,
        },
        {
            path: '/alerts',
            name: 'Alerts',
            component: Alerts,
        },
        {
            path: "/",
            name: 'index'
        },
    ]
});

router.beforeEach((to, from, next) => {
    if (!window.$cookies.isKey('user') && Object.keys(to.query).indexOf('login_error') > -1 && to.query.login_error) {
        localStorage.setItem('login_error', to.query.login_error)
        next('/login');
    } else if (!window.$cookies.isKey('user') && Object.keys(to.query).indexOf('code') > -1 && to.query.code) {
        let redirectCookie = document.cookie.match('requestedBeforeLogin=.+');

        if (!!redirectCookie && redirectCookie.length) {
            let requestedBeforeLogin = redirectCookie[0].split(';')[0].split('=')[1]
            globalStore.requestedBeforeLogin = requestedBeforeLogin;
            document.cookie = 'requestedBeforeLogin=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        }
        localStorage.setItem('cognito_code', to.query.code)
        next('/login');
    } else {
        if (to.path == '/login') {
            if (window.$cookies.isKey('user'))
                next('/dashboard');
            else
                next();
        } else {
            if (!window.$cookies.isKey('user')) {
                if (!window.$cookies.isKey('user') && Object.keys(to.query).indexOf('requester') > -1 && to.query.requester) {
                    localStorage.setItem('requested_provider', to.query.requester)
                }

                if (window.location.pathname.length
                    && window.location.pathname != '/'
                    && window.location.pathname.toLowerCase().indexOf('login') < 0
                    && window.location.pathname.toLowerCase().indexOf('code') < 0
                ) {
                    document.cookie = `requestedBeforeLogin=${window.location.href}; Path=/;`
                    globalStore.requestedBeforeLogin = window.location.href;
                }
                next('/login');
            } else
                next();
        }
    }
});


export default router;



